import clsx from 'clsx';
import { Button, DatePicker } from 'ui';
import ButtonSplit from 'core/modules/atoms/ButtonSplit';
import PropTypes from 'prop-types';
import React from 'react';
import useFooterAutoSaving from './useFooterAutoSaving';

function FooterAutoSaving({
  textButtonCancel = 'Cancel',
  textButtonSuccess = 'Save',
  onCancel,
  onSuccess,
  saveStatus = 'idle',
  options = [],
  buttonOptions,
  statusTest,
  selectedDate = null,
  onChangeSelectedDate = () => {},
  actionSelected,
  onChangeAction = () => {},
  disableSuccess = false,
}) {
  const { t, isVisible, shouldShow, shouldShowDateSchedule } = useFooterAutoSaving({
    onCancel,
    onSuccess,
    saveStatus,
    actionSelected,
    options,
  });

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className={clsx('footer-auto-saving', {
        'footer-auto-saving--visible': isVisible,
      })}
    >
      <div className="footer-auto-saving__saved">
        {/* {saveStatus !== 'idle' && <Icon type={iconType} color="white" size="xl" />} */}
        {/* <p>{statusText}</p> */}
      </div>

      <div className="footer-auto-saving__actions">
        {shouldShowDateSchedule && (
          <div className="footer-auto-saving__date-schedule">
            <DatePicker isNonModal isLabelHidden label={t('common:Select date')} onChange={onChangeSelectedDate} showHour value={selectedDate} />
          </div>
        )}
        {<Button text={t('actions:' + textButtonCancel + '')} variant="inverse-ghost" onClick={onCancel} />}
        {options.length === 0 ? (
          <Button text={t('actions:' + textButtonSuccess + '')} onClick={onSuccess} isDisabled={disableSuccess} />
        ) : (
          <ButtonSplit
            selected={statusTest && buttonOptions.findIndex((opt) => opt.field === statusTest)}
            options={options}
            onChange={onChangeAction}
            onClick={() => onSuccess(actionSelected)}
          />
        )}
      </div>
    </div>
  );
}

FooterAutoSaving.propTypes = {
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  saveStatus: PropTypes.oneOf(['idle', 'saving', 'saved']),
  t: PropTypes.func,
  textButtonCancel: PropTypes.string,
  textButtonSuccess: PropTypes.string,
  options: PropTypes.array,
  onChangeAction: PropTypes.func,
  statusTest: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  onChangeSelectedDate: PropTypes.func,
  buttonOptions: PropTypes.array,
  actionSelected: PropTypes.string,
  disableSuccess: PropTypes.bool,
};

export default FooterAutoSaving;
